import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-maschine-list-view',
  imports: [],
  templateUrl: './maschine.list-view.html',
  styleUrls: ['./maschine.list-view.css'],
})
export class MaschineListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
